var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"control_wrapper"},[_c('ejs-treeview',{attrs:{"id":"treeview","fields":_vm.fields,"showCheckBox":true,"checkedNodes":_vm.checkedNodes,"nodeChecked":_vm.nodeChecked}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }